import { render, staticRenderFns } from "./initialize.vue?vue&type=template&id=08b55c7b&scoped=true&"
import script from "./initialize.vue?vue&type=script&lang=js&"
export * from "./initialize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b55c7b",
  null
  
)

export default component.exports